import { Superfield as SuperfieldUnstyled } from "@marginly/ui/components/input";
import styled, { css } from "styled-components";

import { MinusIcon as MinusIconUnstyled } from "../../../icons/minus-icon";
import { PlusIcon as MinusPlusIcon } from "../../../icons/plus-icon";

const buttonStyles = css`
  min-width: 24px;
  path {
    fill: var(--icon-primary);
  }
`;

export const Superfield = styled(SuperfieldUnstyled)``;

export const MinusIcon = styled(MinusIconUnstyled)`
  ${buttonStyles};
`;

export const PlusIcon = styled(MinusPlusIcon)`
  ${buttonStyles};
`;

export const Dropdown = styled.div`
  position: relative;
`;

export const DropdownBody = styled.div`
  position: absolute;
  bottom: 10px;
  right: -4px;
  transform: translateY(100%);
  border-radius: var(--rounding-radius-xl, 24px);
  background: var(--background-elevated, #fff);
  box-shadow: 0px 8px 32px 0px rgba(51, 20, 0, 0.16);
  padding: 8px 16px;
  width: 280px;
  box-sizing: border-box;
  z-index: 9;
  & > div {
    cursor: pointer;
  }
`;

export const LayerFix = styled.div`
  position: relative;
  z-index: 999;
  .controls {
    z-index: 999;
    left: auto;
  }
  .elevated .coin {
    filter: invert(var(--svg-invert));
  }
  .input__span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  input {
    min-width: auto;
  }

  & > * {
    position: static;
  }
`;
